
export default function Products() {
  return (
    <section id="products" className="py-32 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white text-teal-600 text-sm font-medium uppercase tracking-wider rounded-lg shadow-sm">
              <i className="ri-apps-line text-lg"></i>
              Our Products
            </span>
          </div>
          <h3 className="text-5xl font-bold text-gray-900 mb-6">
            Trusted by Users Worldwide
          </h3>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-product-shop>
          {/* VPN Product Card */}
          <div className="lg:col-span-1 bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] cursor-pointer relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-teal-500/10 to-transparent"></div>
            <div className="relative z-10">
              <div className="flex items-center justify-between mb-8">
                <h4 className="text-3xl font-bold text-white">VPN</h4>
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-full">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
              </div>
              <div className="mb-8">
                <img 
                  src="https://public.readdy.ai/ai/img_res/13a0709214b25dd1ce018be26ba39d99.jpg"
                  alt="VPN Application Interface"
                  className="w-full h-80 object-contain drop-shadow-2xl"
                />
              </div>
              <div className="bg-gradient-to-t from-slate-900 to-transparent pt-8">
                <p className="text-white text-base leading-relaxed">
                  Secure your online presence with our advanced VPN solution. Featuring military-grade encryption, global server network, and lightning-fast connection speeds to protect your privacy and data across all your iOS devices.
                </p>
              </div>
            </div>
          </div>

          {/* Cleaner Product Card */}
          <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] cursor-pointer">
            <div className="inline-block mb-6">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-teal-50 text-teal-600 text-xs font-medium uppercase tracking-wider rounded-lg">
                <i className="ri-flashlight-line"></i>
                Optimization Tool
              </span>
            </div>
            <div className="mb-8">
              <img 
                src="https://readdy.ai/api/search-image?query=iOS%20Cleaner%20application%20interface%20mockup%20on%20iPhone%20showing%20storage%20optimization%20and%20device%20cleaning%20features%2C%20bright%20clean%20UI%20design%20with%20teal%20and%20white%20color%20scheme%2C%20professional%20app%20screenshot%20displaying%20storage%20analysis%20charts%20and%20cleanup%20options%2C%20modern%20minimalist%20interface%20with%20intuitive%20controls%2C%20premium%20mobile%20app%20design%20with%20clear%20visual%20hierarchy%20and%20organized%20layout&width=600&height=800&seq=cleaner-product-mockup-001&orientation=portrait"
                alt="Cleaner Application Interface"
                className="w-full h-80 object-contain"
              />
            </div>
            <h4 className="text-3xl font-bold text-gray-900 mb-4">Cleaner</h4>
            <p className="text-gray-600 text-base leading-relaxed">
              Optimize your device performance with intelligent cleaning algorithms. Remove junk files, manage storage efficiently, and keep your iOS device running at peak performance with our comprehensive optimization suite.
            </p>
          </div>

          {/* Technology Stack Card */}
          <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] cursor-pointer">
            <div className="inline-block mb-6">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-slate-100 text-slate-700 text-xs font-medium uppercase tracking-wider rounded-lg">
                <i className="ri-code-s-slash-line"></i>
                Technology
              </span>
            </div>
            <div className="mb-8 flex items-center justify-center h-80">
              <div className="grid grid-cols-2 gap-6 w-full">
                <div className="flex flex-col items-center justify-center p-6 bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl">
                  <i className="ri-apple-line text-5xl text-orange-600 mb-3"></i>
                  <span className="text-sm font-semibold text-gray-900">Swift</span>
                </div>
                <div className="flex flex-col items-center justify-center p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl">
                  <i className="ri-layout-line text-5xl text-blue-600 mb-3"></i>
                  <span className="text-sm font-semibold text-gray-900">UIKit</span>
                </div>
                <div className="flex flex-col items-center justify-center p-6 bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl">
                  <i className="ri-database-2-line text-5xl text-teal-600 mb-3"></i>
                  <span className="text-sm font-semibold text-gray-900">Core Data</span>
                </div>
                <div className="flex flex-col items-center justify-center p-6 bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl">
                  <i className="ri-cloud-line text-5xl text-purple-600 mb-3"></i>
                  <span className="text-sm font-semibold text-gray-900">CloudKit</span>
                </div>
              </div>
            </div>
            <h4 className="text-3xl font-bold text-gray-900 mb-4">Built with Excellence</h4>
            <p className="text-gray-600 text-base leading-relaxed">
              Leveraging the latest iOS technologies and frameworks to deliver robust, scalable applications that meet the highest standards of quality and performance.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}